import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from 'react';
import omit from 'lodash/omit';
import { Button, FormControl, InputGroup } from '@cancercentrum/rcc-bootstrap';
import { useI18n } from '../i18n';
import { useRegvarValidator } from '../hooks/useRegvarValidator';
const isNewData = (value)=>{
    return !!value.data;
};
export const RegvarResource = /*#__PURE__*/ memo(function RegvarResource(props) {
    const { id, inputRef, value, onLinkClick, ...otherProps } = props;
    const i18n = useI18n();
    const val = useRegvarValidator();
    const onFileSelectionChange = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!e.target.files) {
            return;
        }
        const file = e.target.files[0] || null;
        if (file) {
            const reader = new FileReader();
            reader.addEventListener('load', ()=>{
                if (typeof reader.result !== 'string') {
                    return;
                }
                // Resultatet från readAsDataURL är typ: data:application/pdf;base64,JVBERi0....
                // INCA förväntar sig ren base64-data, så vi behöver strippa bort den inledande biten.
                const strToFind = ';base64,';
                const i = reader.result.indexOf(strToFind);
                if (i === -1) {
                    throw new Error(`Error finding base64 part from resource: ${reader.result}`);
                }
                const data = reader.result.substring(i + strToFind.length);
                const newValue = {
                    fileName: file.name,
                    data: data
                };
                props.onChange(newValue);
            }, false);
            reader.readAsDataURL(file);
        } else {
            props.onChange(null);
        }
    };
    const onFilenameChange = (e)=>{
        const newValue = {
            ...props.value,
            fileName: e.target.value
        };
        props.onChange(newValue);
    };
    const onClear = ()=>{
        props.onChange(null);
    };
    const removeText = i18n.t('button.remove');
    const rest = omit(otherProps, [
        'onChange',
        'regvarMetadata',
        ...val.getValidationPropNames([
            'required'
        ])
    ]);
    let inputNode = null;
    if (!rest.readOnly) {
        inputNode = /*#__PURE__*/ _jsx(FormControl, {
            ...rest,
            type: "file",
            id: id,
            onChange: onFileSelectionChange
        });
    }
    if (value) {
        // Detta är en vald resurs som ännu inte sparats.
        if (isNewData(value)) {
            inputNode = /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(FormControl, {
                        id: id,
                        type: "text",
                        onBlur: onFilenameChange,
                        defaultValue: value.fileName,
                        ref: inputRef
                    }, "withData"),
                    /*#__PURE__*/ _jsx(InputGroup.Button, {
                        children: /*#__PURE__*/ _jsx(Button, {
                            bsStyle: "danger",
                            onClick: onClear,
                            children: removeText
                        })
                    })
                ]
            });
        } else if (value.url) {
            const removeButton = !rest.disabled && !rest.readOnly && /*#__PURE__*/ _jsx("button", {
                type: "button",
                className: "btn btn-xs btn-danger pull-right",
                onClick: onClear,
                children: removeText
            });
            inputNode = /*#__PURE__*/ _jsxs("div", {
                className: "form-control-plaintext",
                children: [
                    removeButton,
                    /*#__PURE__*/ _jsxs("a", {
                        href: `${value.url}?contentDisposition=inline`,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        onClick: onLinkClick,
                        children: [
                            value.fileName,
                            " ",
                            /*#__PURE__*/ _jsx("i", {
                                className: "fa fa-external-link"
                            })
                        ]
                    })
                ]
            });
        }
    }
    return inputNode;
});
